/**
 * @generated SignedSource<<9f078481a5ae4b8568d06c4eb919c8eb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConditionalFormattingEntrypointProvider_view$data = {
  readonly conditionalFormattingRules: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly expression: {
          readonly __typename: "JiraFormattingMultipleValueOperand";
          readonly fieldId: string;
          readonly values: ReadonlyArray<string>;
        } | {
          readonly __typename: "JiraFormattingNoValueOperand";
          readonly fieldId: string;
        } | {
          readonly __typename: "JiraFormattingSingleValueOperand";
          readonly fieldId: string;
          readonly value: string;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        };
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ConditionalFormattingEntrypointProvider_view";
};
export type ConditionalFormattingEntrypointProvider_view$key = {
  readonly " $data"?: ConditionalFormattingEntrypointProvider_view$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConditionalFormattingEntrypointProvider_view">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "fieldId"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "name": "ConditionalFormattingEntrypointProvider_view",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        }
      ],
      "concreteType": "JiraFormattingRuleConnection",
      "kind": "LinkedField",
      "name": "conditionalFormattingRules",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraFormattingRuleEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraFormattingRule",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "expression",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "__typename"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        {
                          "kind": "ScalarField",
                          "name": "value"
                        }
                      ],
                      "type": "JiraFormattingSingleValueOperand"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        {
                          "kind": "ScalarField",
                          "name": "values"
                        }
                      ],
                      "type": "JiraFormattingMultipleValueOperand"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/)
                      ],
                      "type": "JiraFormattingNoValueOperand"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraSpreadsheetView",
  "abstractKey": "__isJiraSpreadsheetView"
};
})();

(node as any).hash = "ce53295074ed8f1325839f27eefc3643";

export default node;
